// Utility helpers for working with IDs

/**
 * Return a short, display-friendly form of a UUID.
 * - If `id` looks like a UUID, returns the last segment (12 hex chars).
 * - Otherwise, returns the last 12 characters as a fallback.
 * - For inputs shorter than 12 chars, returns the input as-is.
 */
export function shortenUuid(id: string | null | undefined): string {
  if (!id || typeof id !== 'string') return '';

  const uuidLastSegment = id.match(
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-([0-9a-fA-F]{12})$/
  );
  if (uuidLastSegment && uuidLastSegment[1]) {
    return uuidLastSegment[1];
  }

  // Fallback: last 12 characters for non-UUID strings
  if (id.length > 12) return id.slice(-12);
  return id;
}
